import React, {useCallback, useState, useContext, useEffect} from 'react';
import {Popup, Input, Button, setOptions, toast, Select, Checkbox, confirm, Datepicker} from "@mobiscroll/react";
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import {Listview, NavItem, TabNav} from '@mobiscroll/react4';
import '@mobiscroll/react4/dist/css/mobiscroll.min.css';
import '../styles/dashboardHeaderAccount.css';
import dayjs from "dayjs";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faXmark} from "@fortawesome/pro-duotone-svg-icons";
import Empty from "../utils/Empty";
import Loading from "../utils/Loading";
import CardToken from "../utils/CardToken";
import {NetworkContext} from "../utils/NetworkContext";

setOptions({
    theme: 'ios',
    themeVariant: 'light',
});

function DashboardHeaderAccount({locale, dialog, Dialog, width, setUserData, configuration}) {
    const {wsCall, wsResponse, setWsResponse} = useContext(NetworkContext);
    const [tab, setTab] = useState(null);
    const [mobiUsers, setMobiUsers] = useState([]);
    const [mobiConversations, setMobiConversations] = useState([]);
    const [results, setResults] = useState([]);
    const [text, setText] = useState(null);
    const [displayName, setDisplayName] = useState(null);
    const [title, setTitle] = useState(null);
    const [loginTitle, setLoginTitle] = useState(false);
    const [accountModel, setAccountModel] = useState(false);
    const [model, setModel] = useState(null);
    const [accountData, setAccountData] = useState({});
    const [viewConfiguration, setViewConfiguration] = useState(false);
    const [update, setUpdate] = useState(false);
    const [loading, setLoading] = useState(true);
    const [models, setModels] = useState([]);
    const [stripe, setStripe] = useState({});
    const [stripeUpdate, setStripeUpdate] = useState({});
    const [billing, setBilling] = useState({});
    const [ui, setUi] = useState({});
    const [usage, setUsage] = useState([]);
    const [summary, setSummary] = useState({});
    const [date, setDate] = useState(dayjs().format());

    const DialogClose = useCallback(() => {
        Dialog({view: 'close'});
    }, [Dialog]);

    const BillingTotal = () => {
        const seats = summary.find(item => item.type === 'seats');
        const tokens = summary.find(item => item.type === 'tokens');
        const seatsTotal = seats.amount * seats.cost;
        const total = seatsTotal + tokens.cost;

        return total.toFixed(2);
    }

    const ConfigurationSave = () => {
        setLoading(true);

        const message = {
            type: 'wss',
            path: 'account-configuration',
            action: 'update',
            data: {
                displayName: displayName,
                title: title,
                loginTitle: loginTitle,
                accountModel: accountModel
            }
        }
        if (accountModel && model) {
            message.data.model = model;
        } else if (accountModel && !model) {
            message.data.model = models[0].value;
        } else if (!accountModel) {
            message.data.model = null;
        }
        wsCall(message);
    }

    const Usage = useCallback(data => {
        setLoading(true);
        const itemDate = dayjs(data).format("YYYY-M-D");
        setDate(dayjs(data).format());

        const message = {
            type: 'wss',
            path: 'account-usage',
            action: 'get',
            data: {
                date: itemDate
            }
        };
        wsCall(message);
    }, [wsCall]);

    const AccountData = useCallback(() => {
        setLoading(true);
        const itemDate = dayjs().format("YYYY-M-D");

        const message = {
            type: 'wss',
            path: 'account-data',
            action: 'get',
            data: {
                date: itemDate
            }
        };
        wsCall(message);
    }, [wsCall]);

    const Users = useCallback(() => {
        setLoading(true);

        const message = {
            type: 'wss',
            path: 'users',
            action: 'get',
            data: {}
        };
        wsCall(message);
    }, [wsCall]);

    const Conversations = useCallback(() => {
        setLoading(true);

        const message = {
            type: 'wss',
            path: 'account-conversations',
            action: 'get',
            data: {}
        };
        wsCall(message);
    }, [wsCall]);

    const InputSuggestion = data => {
        setText(data);
        const query = data.trim().toLowerCase();

        if (!query) {
            setResults([]);
            return;
        }

        const filtered = tab === 'users' ? mobiUsers.filter(item =>
            item.text.toLowerCase().includes(query)
        ) : mobiConversations.filter(item =>
            item.text.toLowerCase().includes(query)
        );

        setResults(filtered);
    };

    const ButtonNav = useCallback(data => {
        setLoading(true);
        setSummary({});

        if (data === 'users') {
            Users();
        } else if (data === 'billing') {
            AccountData();
        } else if (data === 'configuration') {
            AccountData();
        } else if (data === 'conversations') {
            Conversations();
        } else if (data === 'usage') {
            Usage();
        }

        setTab(data);
    }, [AccountData, Users, Conversations, Usage]);

    const ButtonNext = data => {
        setLoading(true);

        const message = {
            type: 'wss',
            path: 'account-billing',
            action: 'update',
            data: {
                stripe: data
            }
        }
        wsCall(message);
    }

    const ButtonClose = () => {
        if (tab === 'configuration' &&
            ((displayName !== accountData.displayName) ||
                (title !== accountData.title) ||
                (loginTitle !== ui.login.title) ||
                (accountModel !== ui.dashboard.model) ||
                (model !== accountData.model))) {
            ConfigurationSave();
        } else {
            DialogClose();
        }
    }

    const SelectUsers = data => {
        if (data) {
            setLoading(true);

            const message = {
                type: 'wss',
                path: 'account-user',
                action: 'get',
                data: {
                    userData: data
                }
            };
            wsCall(message);
        }
    }

    const SelectConversations = data => {
        if (data) {

            confirm({
                title: locale.dashboardHeaderAccount.aw,
                message: locale.dashboardHeaderAccount.ax,
                okText: locale.dashboardHeaderAccount.ay,
                cancelText: locale.dashboardHeaderAccount.az,
                callback: (res) => {
                    if (res) {
                        setLoading(true);

                        const message = {
                            type: 'wss',
                            path: 'account-conversation',
                            action: 'delete',
                            data: {
                                user: data
                            }
                        };
                        wsCall(message);
                    }
                }
            });
        }
    }

    const ClickRegistration = () => {
        setUserData({});
        Dialog({view: 'dashboardHeaderAccountUser'});
    }

    const ClickUpdateCard = () => {
        setUpdate(true);
    }

    const ListItem = data => {

        if (tab === 'usage') {
            const id = data.item.user + '-' + data.item.model;

            return <li data-id={id} className="cs-dashboard-header-account-list-multi" >
                <div className="mbsc-row cs-dashboard-header-account-list" >
                    <div>
                        <div className="mbsc-txt-muted">
                            <span className="mbsc-bold">{data.item.user}</span><span className="mbsc-bold cs-dashboard-header-account-button-nav">&nbsp;|&nbsp;</span>{data.item.model}
                        </div>
                        {data.item.itemOutput !== 0 ?
                            <div className="mbsc-row mbsc-txt-s cs-dashboard-header-account-item-txt">
                                <span className="mbsc-bold cs-dashboard-header-account-button-nav cs-dashboard-header-account-accounts-list-icon">📦&nbsp;</span>
                                <span className="mbsc-txt-muted cs-dashboard-header-account-accounts-list-text" >{data.item.itemOutput.toLocaleString('en-US')}</span>
                                <span className="mbsc-bold cs-dashboard-header-account-button-nav cs-dashboard-header-account-accounts-list-icon">&nbsp;&nbsp;@&nbsp;</span>
                                <span className="mbsc-bold mbsc-txt-muted cs-dashboard-header-account-accounts-list-text" >${data.item.tokensTotalCost.toFixed(2)}</span>
                            </div>
                            :
                            <div className="mbsc-row mbsc-txt-s cs-dashboard-header-account-item-txt">
                                {data.item.tokensImage !== 0 &&
                                    <span className="mbsc-bold cs-dashboard-header-operations-button-nav cs-dashboard-header-account-accounts-list-icon">👁&nbsp;</span>
                                }
                                {data.item.tokensImage !== 0 &&
                                    <span className="mbsc-txt-muted cs-dashboard-header-operations-accounts-list-text" >{data.item.tokensImage.toLocaleString('en-US')}</span>
                                }
                                <span className="mbsc-bold cs-dashboard-header-account-button-nav">{data.item.tokensImage !== 0 && '\u00A0\u00A0'}⬇&nbsp;</span>
                                <span className="mbsc-txt-muted cs-dashboard-header-account-accounts-list-text" >{data.item.tokensInput.toLocaleString('en-US')}</span>
                                <span className="mbsc-bold cs-dashboard-header-account-button-nav">&nbsp;&nbsp;⬆&nbsp;</span>
                                <span className="mbsc-txt-muted cs-dashboard-header-account-accounts-list-text" >{data.item.tokensOutput.toLocaleString('en-US')}</span>
                                <span className="mbsc-bold cs-dashboard-header-account-button-nav cs-dashboard-header-account-accounts-list-icon">&nbsp;&nbsp;@&nbsp;</span>
                                <span className="mbsc-bold mbsc-txt-muted cs-dashboard-header-account-accounts-list-text" >${data.item.tokensTotalCost.toFixed(2)}</span>
                            </div>
                        }
                    </div>
                </div>
            </li>;
        } else if (tab === 'billing') {
            const id = data.item.type;

            return <li data-id={id} className="cs-dashboard-header-account-list-multi" >
                <div className="mbsc-row cs-dashboard-header-account-list" >
                    <div className="mbsc-col cs-dashboard-header-account-list-item" >
                        <div>
                            <div className="mbsc-bold">
                                {data.item.type === 'seats' &&
                                    <span>{locale.dashboardHeaderAccount.f}</span>
                                }
                                {data.item.type === 'tokens' &&
                                    <span>{locale.dashboardHeaderAccount.q}</span>
                                }
                            </div>
                            <div className="mbsc-row mbsc-txt-s cs-dashboard-header-account-item-txt">
                                <span className="mbsc-txt-muted cs-dashboard-header-account-accounts-list-text" >{data.item.amount.toLocaleString('en-US')}</span>
                                {data.item.type === 'seats' &&
                                    <span className="mbsc-txt-muted cs-dashboard-header-account-accounts-list-text" >&nbsp;{locale.dashboardHeaderAccount.al} x ${data.item.cost.toFixed(2)} / {locale.dashboardHeaderAccount.ao}</span>
                                }
                                {data.item.type === 'tokens' &&
                                    <span className="mbsc-txt-muted cs-dashboard-header-account-accounts-list-text" >&nbsp;{locale.dashboardHeaderAccount.r}</span>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="mbsc-col-auto cs-dashboard-header-operations-list-item" >
                        {data.item.type === 'seats' &&
                            <div>
                                <span className="mbsc-txt-muted">@</span>&nbsp;<span className="mbsc-bold">${data.item.amount * data.item.cost.toFixed(2)}</span>
                            </div>
                        }
                        {data.item.type === 'tokens' &&
                            <div>
                                <span className="mbsc-txt-muted">@</span>&nbsp;<span className="mbsc-bold">${data.item.cost.toFixed(2)}</span>
                            </div>
                        }
                    </div>
                </div>
            </li>;
        }
    }

    const DeleteConversation = useCallback(data => {
        if (data.toast) {
            Conversations();
        }
    }, [Conversations]);

    const GetUsers = useCallback(data => {
        if (data.mobiUsers) {
            setMobiUsers(data.mobiUsers);
        }
        setLoading(false);
    }, []);

    const GetAccountConversations = useCallback(data => {
        if (data.mobiConversations) {
            setMobiConversations(data.mobiConversations);
        }
        setLoading(false);
    }, []);

    const GetAccountUser = useCallback(data => {
        if (data.userData) {
            setUserData(data.userData);
            Dialog({view: 'dashboardHeaderAccountUser'});
        }
        setLoading(false);
    }, [Dialog]);

    const GetAccountUsage = useCallback(data => {
        if (data.usage) {
            setUsage(data.usage);
        }
        if (data.summary) {
            setSummary(data.summary);
        }
        setLoading(false);
    }, []);

    const GetAccountData = useCallback(data => {
        const item = {
            type: data.type ? data.type : null,
            logo: data.logo ? data.logo : null,
            displayName: data.displayName ? data.displayName : null,
            title: data.title ? data.title : null,
            model: data.model ? data.model : null
        }
        setAccountData(item);
        if (data.models) {
            setModels(data.models);
        }
        if (data.stripe) {
            setStripe(data.stripe);
        } else {
            setStripe({});
        }
        if (data.billing) {
            setBilling(data.billing);
        }
        if (data.ui) {
            setUi(data.ui);
            setLoginTitle(data.ui.login.title);
            setAccountModel(data.ui.dashboard.model);
        }
        if (data.displayName) {
            setDisplayName(data.displayName);
        }
        if (data.title) {
            setTitle(data.title);
        }
        if (data.model) {
            setModel(data.model);
        }
        if (data.summary) {
            setSummary(data.summary);
        }
        if (data.toast) {
            setLoading(false);
        }
        if (!tab && data.type && data.type === 'linked') {
            ButtonNav('conversations');
        } else if (!tab && data.type && data.type === 'full' && data.billing && data.billing.plan !== 'personal') {
            ButtonNav('users');
        } else if (!tab && !(data.type && data.type === 'full' && data.billing && data.billing.plan !== 'personal')) {
            ButtonNav('billing');
        }
    }, [tab, ButtonNav]);

    const UpdateAccountConfiguration = useCallback(data => {
        if (data.toast) {
            DialogClose();
        }
    }, [DialogClose]);

    const UpdateAccountBilling = useCallback(data => {
        if (data.toast) {
            setUpdate(false);
            toast({message: locale.dashboardHeaderAccount.m, color: 'info', display: 'bottom', duration: 1000});
            AccountData();
        }
        if (data.error) {
            toast({message: locale.dashboardHeaderAccount.g, color: 'danger', display: 'bottom', duration: 3000});
        }
    }, [AccountData, locale.dashboardHeaderAccount.m, locale.dashboardHeaderAccount.g]);

    useEffect(() => {
        if (wsResponse && wsResponse && !Empty(wsResponse) && wsResponse.action === 'get' && wsResponse.path === 'users') {
            GetUsers(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, GetUsers, setWsResponse]);

    useEffect(() => {
        if (wsResponse && wsResponse && !Empty(wsResponse) && wsResponse.action === 'get' && wsResponse.path === 'account-conversations') {
            GetAccountConversations(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, GetAccountConversations, setWsResponse]);

    useEffect(() => {
        if (wsResponse && wsResponse && !Empty(wsResponse) && wsResponse.action === 'get' && wsResponse.path === 'account-data') {
            GetAccountData(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, GetAccountData, setWsResponse]);

    useEffect(() => {
        if (wsResponse && wsResponse && !Empty(wsResponse) && wsResponse.action === 'get' && wsResponse.path === 'account-usage') {
            GetAccountUsage(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, GetAccountUsage, setWsResponse]);

    useEffect(() => {
        if (wsResponse && wsResponse && !Empty(wsResponse) && wsResponse.action === 'get' && wsResponse.path === 'account-user') {
            GetAccountUser(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, GetAccountUser, setWsResponse]);

    useEffect(() => {
        if (wsResponse && wsResponse && !Empty(wsResponse) && wsResponse.action === 'update' && wsResponse.path === 'account-configuration') {
            UpdateAccountConfiguration(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, UpdateAccountConfiguration, setWsResponse]);

    useEffect(() => {
        if (wsResponse && wsResponse && !Empty(wsResponse) && wsResponse.action === 'update' && wsResponse.path === 'account-billing') {
            UpdateAccountBilling(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, UpdateAccountBilling, setWsResponse]);

    useEffect(() => {
        if (wsResponse && wsResponse && !Empty(wsResponse) && wsResponse.action === 'delete' && wsResponse.path === 'conversation') {
            DeleteConversation(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, DeleteConversation, setWsResponse]);

    useEffect(() => {
        AccountData();
    }, []);

    return (
        <Popup className="cs-dashboard-header-account-popup" maxHeight="700" display="center" fullScreen={true} scrollLock={false} closeOnOverlayClick={false} closeOnEsc={false} buttons={[]} isOpen={dialog.view === 'dashboardHeaderAccount'} onClose={DialogClose}>
            <div className="mbsc-grid cs-dashboard-header-account-header-col">
                <div className="mbsc-row cs-dashboard-header-account-header-row">
                    {width > 576 &&
                        <div className="mbsc-col cs-dashboard-header-account-header-col" />
                    }
                    <div className={width > 576 ? "mbsc-col cs-dashboard-header-account-header-col mbsc-align-center" : "mbsc-col cs-dashboard-header-account-header-col"} >
                        <Button className="cs-dashboard-header-account-title-button mbsc-bold mbsc-txt-muted" variant="flat" >
                            {locale.dashboardHeaderAccount.c}
                        </Button>
                    </div>
                    <div className="mbsc-col cs-dashboard-header-account-header-col mbsc-align-right">
                        <Button disabled={loading} color="primary" variant="flat" className="mbsc-bold cs-dashboard-header-account-close-button" onClick={() => ButtonClose()} >
                            &nbsp;<FontAwesomeIcon className="cs-dashboard-header-account-close-icon" icon={faXmark} />
                        </Button>
                    </div>
                </div>
            </div>
            {loading &&
                <Loading />
            }
            {!loading &&
                <TabNav theme="mobiscroll" themeVariant="light" display='inline' className="cs-dashboard-header-account-nav-tab" >
                    {accountData.type === 'linked' && configuration.billingStatus === 'active' &&
                        <NavItem disabled={tab === 'billing' && update} selected={tab === 'conversations'} onClick={() => !(tab === 'billing' && update) && tab !== 'conversations' && ButtonNav('conversations')} >
                            <span className={tab === 'conversations' ? 'mbsc-bold cs-dashboard-header-account-button-nav' : ''} >{locale.dashboardHeaderAccount.au}</span>
                        </NavItem>
                    }
                    {accountData.type === 'full' && billing.plan !== 'personal' && configuration.billingStatus === 'active' &&
                        <NavItem disabled={tab === 'billing' && update} selected={tab === 'users'} onClick={() => !(tab === 'billing' && update) && tab !== 'users' && ButtonNav('users')} >
                            <span className={tab === 'users' ? 'mbsc-bold cs-dashboard-header-account-button-nav' : ''} >{locale.dashboardHeaderAccount.y}</span>
                        </NavItem>
                    }
                    {configuration.billingStatus === 'active' &&
                        <NavItem disabled={tab === 'usage' && update} selected={tab === 'usage'} onClick={() => !(tab === 'usage' && update) && tab !== 'usage' && ButtonNav('usage')} >
                            <span className={tab === 'usage' ? 'mbsc-bold cs-dashboard-header-account-button-nav' : ''} >{locale.dashboardHeaderAccount.h}</span>
                        </NavItem>
                    }
                    <NavItem disabled={tab === 'billing' && update} selected={tab === 'billing'} onClick={() => !(tab === 'billing' && update) && tab !== 'billing' && ButtonNav('billing')} >
                        <span className={tab === 'billing' ? 'mbsc-bold cs-dashboard-header-account-button-nav' : ''} >{locale.dashboardHeaderAccount.z}</span>
                    </NavItem>
                    {configuration.billingStatus === 'active' &&
                        <NavItem disabled={tab === 'billing' && update} selected={tab === 'configuration'} onClick={() => !(tab === 'billing' && update) && tab !== 'configuration' && ButtonNav('configuration')} >
                            <span className={tab === 'configuration' ? 'mbsc-bold cs-dashboard-header-account-button-nav' : ''} >{locale.dashboardHeaderAccount.aa}</span>
                        </NavItem>
                    }
                </TabNav>
            }
            {!loading && tab === 'conversations' &&
                <>
                    <div className="cs-dashboard-header-account-helper">
                        <p>
                            {locale.dashboardHeaderAccount.av}
                        </p>
                    </div>
                    <div className="mbsc-form-group">
                        {mobiConversations.length > 1 &&
                            <Input
                                inputStyle="underline"
                                placeholder={locale.dashboardHeaderAccount.ac}
                                labelStyle="floating"
                                type="text"
                                name="search"
                                value={text}
                                onChange={ev => InputSuggestion(ev.target.value)}
                            />
                        }
                        {mobiConversations.length !== 0 &&
                            <Select
                                animation="slide-down"
                                inputStyle="underline"
                                dropdown={false}
                                placeholder={locale.dashboardHeaderAccount.ad}
                                labelStyle="floating"
                                touchUi={false}
                                rows={10}
                                display="inline"
                                selectMultiple={false}
                                data={text ? results : mobiConversations}
                                onChange={args => SelectConversations(args.value)}
                            />
                        }
                    </div>

                </>
            }
            {!loading && tab === 'users' &&
                <>
                    <div className="cs-dashboard-header-account-helper">
                        <p>
                            {locale.dashboardHeaderAccount.ae}
                            <a className="cs-dashboard-header-account-links" href="#" onClick={ClickRegistration}>{mobiUsers.length !== 0 ? locale.dashboardHeaderAccount.ab : locale.dashboardHeaderAccount.b}</a>
                        </p>
                    </div>
                    <div className="mbsc-form-group">
                        {mobiUsers.length > 1 &&
                            <Input
                                inputStyle="underline"
                                placeholder={locale.dashboardHeaderAccount.ac}
                                labelStyle="floating"
                                type="text"
                                name="search"
                                value={text}
                                onChange={ev => InputSuggestion(ev.target.value)}
                            />
                        }
                        {mobiUsers.length !== 0 &&
                            <Select
                                animation="slide-down"
                                inputStyle="underline"
                                dropdown={false}
                                placeholder={locale.dashboardHeaderAccount.ad}
                                labelStyle="floating"
                                touchUi={false}
                                rows={13}
                                display="inline"
                                selectMultiple={false}
                                data={text ? results : mobiUsers}
                                onChange={args => SelectUsers(args.value)}
                            />
                        }
                    </div>
                </>
            }
            {!loading && tab === 'usage' &&
                <>
                    <div className="cs-dashboard-header-account-helper">
                        <p>{locale.dashboardHeaderAccount.i}</p>
                    </div>
                    <div className="mbsc-col cs-dashboard-header-account-header-col cs-dashboard-header-account-border" >
                        <Button color="primary" variant="flat" className="cs-dashboard-header-operations-picker cs-dashboard-header-operations-button mbsc-bold mbsc-txt-muted" >
                            <Datepicker
                                label="text"
                                labelStyle="stacked"
                                controls={['date']}
                                touchUi={width <= 576}
                                value={date}
                                inputComponent="input"
                                max={dayjs().format()}
                                dateFormat="MMMM YYYY"
                                dateWheels="|YYYY | MMM|"
                                buttons={['set', 'cancel']}
                                onChange={ev => Usage(ev.value)}
                                setText={locale.dashboardHeaderAccount.aj}
                                cancelText={locale.dashboardHeaderAccount.az}
                            />
                        </Button>
                    </div>
                    <div className="cs-dashboard-header-account-scroll-usage">
                        <Listview
                            theme="ios"
                            themeVariant="light"
                            select="single"
                            itemType={ListItem}
                            data={usage}
                        />
                    </div>
                    <div className="mbsc-button-group-block cs-dashboard-header-account-summary-block">
                        <Button color="primary" variant="flat" className="cs-dashboard-header-account-button-summary mbsc-txt-muted" >
                            {summary.itemOutput && summary.itemOutput !== 0 &&
                                <>
                                    <span className="mbsc-bold" >{locale.dashboardHeaderAccount.ak}:&nbsp;{summary && summary.itemOutput && summary.itemOutput.toLocaleString('en-US')}</span>
                                    <span className="mbsc-bold" >&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                </>
                            }
                            <span className="mbsc-bold" >{locale.dashboardHeaderAccount.x}:&nbsp;{summary && summary.tokensTotal && summary.tokensTotal.toLocaleString('en-US')}</span>
                            <span className="mbsc-bold" >&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                            <span className="mbsc-bold" >{locale.dashboardHeaderAccount.ai}:&nbsp;${summary && summary.tokensTotalCost && summary.tokensTotalCost.toFixed(2)}</span>
                        </Button>
                    </div>
                </>
            }
            {!loading && tab === 'billing' &&
                <>
                    <div className="cs-dashboard-header-account-helper">
                        <p>{locale.dashboardHeaderAccount.o}</p>
                    </div>
                    <div className="mbsc-col cs-dashboard-header-account-header-col cs-dashboard-header-account-border" >
                        <Button color="primary" variant="flat" className="cs-dashboard-header-account-button-summary mbsc-bold mbsc-txt-muted" >
                            {locale.dashboardHeaderAccount.p}
                        </Button>
                    </div>
                    <Listview
                        theme="ios"
                        themeVariant="light"
                        select="single"
                        itemType={ListItem}
                        data={summary}
                    />
                    <div className="mbsc-button-group-block cs-dashboard-header-account-summary-block">
                        <Button color="primary" variant="flat" className="cs-dashboard-header-account-button-summary mbsc-txt-muted" >
                            {locale.dashboardHeaderAccount.at}:<span className="mbsc-bold" >&nbsp;${BillingTotal()}</span>
                            <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                            {locale.dashboardHeaderAccount.ba}:<span className="mbsc-bold" >&nbsp;{dayjs(stripe.periodEnd).format('YYYY-MM-DD')}</span>
                        </Button>
                    </div>
                    <div className="mbsc-col cs-dashboard-header-account-header-col cs-dashboard-header-account-border" >
                        <Button color="primary" variant="flat" className="cs-dashboard-header-account-button-summary mbsc-bold mbsc-txt-muted" >
                            {locale.dashboardHeaderAccount.bb}
                        </Button>
                    </div>
                    {!Empty(stripe) && stripe.last4 && !update &&
                        <Input disabled inputStyle="underline" labelStyle="floating" label={locale.dashboardHeaderAccount.d} type="text" name="number" value={'XXXX XXXX XXXXX ' + stripe.last4} />
                    }
                    {!Empty(stripe) && stripe.last4 && !update &&
                        <div className="cs-dashboard-header-account-update-cc mbsc-align-right">
                            <a className="cs-dashboard-header-account-links" href="#" onClick={ClickUpdateCard}>{locale.dashboardHeaderAccount.s}</a>
                        </div>
                    }
                    {configuration.rootAccount && !update &&
                        <div className="mbsc-button-group-block cs-dashboard-header-account-summary-block cs-dashboard-header-account-block-button-helper">
                            <Button color="primary" variant="flat" className="cs-dashboard-header-account-button-helper mbsc-txt-muted" >
                                {locale.dashboardHeaderAccount.as}
                            </Button>
                        </div>
                    }
                    {(Empty(stripe) || (!Empty(stripe) && !stripe.last4)) && !update && !configuration.rootAccount &&
                        <div className="mbsc-button-group-block cs-dashboard-header-account-summary-block cs-dashboard-header-account-block-button-helper">
                            <Button color="primary" variant="flat" className="cs-dashboard-header-account-button-helper mbsc-txt-muted" >
                                {locale.dashboardHeaderAccount.l}
                            </Button>
                        </div>
                    }
                    {update &&
                        <div className="cs-dashboard-header-account-card">
                            <CardToken
                                textNext={locale.dashboardHeaderAccount.n}
                                Next={ButtonNext}
                                textBack={null}
                                Back={null}
                                setStripe={setStripeUpdate}
                            />
                        </div>
                    }
                    <div className="mbsc-button-group-block cs-dashboard-header-account-summary-block">
                        <Button color="primary" variant="flat" className="cs-dashboard-header-account-button-helper-active mbsc-txt-muted" onClick={() => ButtonNav('usage')}>
                            <span className="mbsc-txt-s">{locale.dashboardHeaderAccount.e}</span>
                        </Button>
                    </div>
                </>
            }
            {!loading && tab === 'configuration' && !viewConfiguration &&
                <>
                    <div className="cs-dashboard-header-account-helper">
                        <p>
                            {locale.dashboardHeaderAccount.v}
                        </p>
                        <p>
                            {locale.dashboardHeaderAccount.t}
                        </p>
                    </div>
                    <div className="mbsc-form-group">
                        <Checkbox
                            cssClass="cs-dashboard-header-account-checkbox mbsc-bold"
                            color="info"
                            label={locale.dashboardHeaderAccount.u}
                            checked={viewConfiguration}
                            position="start"
                            onChange={ev => setViewConfiguration(ev.target.checked)}
                        />
                        {!accountModel &&
                            <Checkbox
                                cssClass="cs-dashboard-header-account-checkbox mbsc-bold"
                                color="info"
                                label={locale.dashboardHeaderAccount.am}
                                description={locale.dashboardHeaderAccount.w}
                                checked={accountModel}
                                position="start"
                                onChange={ev => setAccountModel(ev.target.checked)}
                            />
                        }
                        {!accountModel &&
                            <Select
                                animation="slide-down"
                                dropdown={false}
                                inputStyle="underline"
                                label={locale.dashboardHeaderAccount.an}
                                labelStyle="floating"
                                rows={models.length}
                                display="anchored"
                                touchUi={false}
                                value={model}
                                data={models}
                                onChange={args => setModel(args.value)}
                            />
                        }
                    </div>
                </>
            }
            {!loading && tab === 'configuration' && viewConfiguration &&
                <div className="cs-dashboard-header-account-scroll">
                    <div className="cs-dashboard-header-account-helper">
                        <p>
                            {locale.dashboardHeaderAccount.k}
                        </p>
                        <p>
                            {locale.dashboardHeaderAccount.j}
                        </p>
                    </div>
                    <div className="mbsc-form-group">
                        <Input inputStyle="underline" labelStyle="floating" label={locale.dashboardHeaderAccount.af} type="text" name="displayName" value={displayName} error={true} errorMessage={locale.dashboardHeaderAccount.ap} onChange={ev => setDisplayName(ev.target.value)}/>
                        <Input inputStyle="underline" labelStyle="floating" label={locale.dashboardHeaderAccount.ag} type="text" name="title" value={title} error={true} errorMessage={locale.dashboardHeaderAccount.aq} onChange={ev => setTitle(ev.target.value)}/>
                        {title &&
                            <Checkbox
                                cssClass="cs-dashboard-header-account-checkbox mbsc-bold"
                                color="info"
                                label={locale.dashboardHeaderAccount.ah}
                                description={locale.dashboardHeaderAccount.ar}
                                checked={loginTitle}
                                position="start"
                                onChange={ev => setLoginTitle(ev.target.checked)}
                            />
                        }
                        <Checkbox
                            cssClass="cs-dashboard-header-account-checkbox mbsc-bold"
                            color="info"
                            label={locale.dashboardHeaderAccount.am}
                            description={locale.dashboardHeaderAccount.w}
                            checked={accountModel}
                            position="start"
                            onChange={ev => setAccountModel(ev.target.checked)}
                        />
                        {!accountModel &&
                            <Select
                                animation="slide-down"
                                dropdown={false}
                                inputStyle="underline"
                                label={locale.dashboardHeaderAccount.an}
                                labelStyle="floating"
                                rows={models.length}
                                display="anchored"
                                touchUi={false}
                                value={model}
                                data={models}
                                onChange={args => setModel(args.value)}
                            />
                        }
                    </div>
                </div>
            }
        </Popup>
    );
}

export default DashboardHeaderAccount;
